// @mui
import { LoadingButton } from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import { useTemplatesContext } from '../hooks/useTemplatesContext';
import { translateKey } from 'src/locales/translate';


// ----------------------------------------------------------------------

export default function TemplatesDeleteModal() {
  const {
    isDeleteTemplateLoading,
    isDeleteModalOpen,
    handleCloseDeleteModal,
    handleDeleteTemplate,
  } = useTemplatesContext();
  return (
    <Dialog open={isDeleteModalOpen} onClose={handleCloseDeleteModal}>
      <DialogTitle>{translateKey("hardcoded.usun_szablon")}</DialogTitle>

      <DialogContent sx={{ maxWidth: '400px' }}>
        <DialogContentText id="alert-dialog-description">{translateKey("hardcoded.czy_na_pewno_chcesz_usunac_ten_szablon")}</DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button
          variant="outlined"
          color="inherit"
          onClick={handleCloseDeleteModal}
        >{translateKey("common.close")}</Button>
        <LoadingButton
          variant="contained"
          color="error"
          onClick={handleDeleteTemplate}
          disabled={isDeleteTemplateLoading}
          loading={isDeleteTemplateLoading}
        >
          <span>{translateKey("common.remove")}</span>
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
}
